// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bb1e2b45","667":"13adb887","777":"4fce87c2","977":"ee531c17"}[chunkId] + ".chunk.js";
};